import { createContext, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { BASE_URL } from '../utils/helpers.util'



const AuthState = createContext()

export const useAuth = () => useContext(AuthState)

export default function AuthProvider(props){
    
    const [state, setState] = useState({
        loggedIn: false,
        loading: true,
        loginModal: false,
        token: "",
        email:"",
    })
    
    async function checkAuthStatus(){
        try {
            const {data} = await axios.get(BASE_URL + "/users/me")
            setState(oldState => ({
                ...oldState,
                loading: false,
                loggedIn: true
            }))
        } catch(err) {
            setState(oldState => ({...oldState, loading: false}))
        } 
    }   
    
    async function loginUser(email, password){
        try {
            const {data} = await axios.post(BASE_URL + "/auth/signin", {
                email, pwd:password
            })
            
            setState(oldState => ({
                loggedIn: true,
                email: email,
                token: data.IDToken
            }))
            
            
        } catch(err) {
            throw new Error(err)
        }
    }
    
    
    const authState = {
        state,
        methods:{
            goToPayments(){
                if(!state.loggedIn) return authState.methods.toggleLoginModal()    
            },
            toggleLoginModal(){
                setState(oldState => ({
                    ...oldState,
                    loginModal: !oldState.loginModal
                }))
            },
            loginUser
        }
    }
    
    
    
     
    useEffect(() => {
        axios.defaults.withCredentials = true
        checkAuthStatus()
    }, [])
    
    return (
        <AuthState.Provider value={authState}>
            {state.loginModal ? <div onClick={authState.methods.toggleLoginModal}>ciao</div> : props.children}
        </AuthState.Provider>
    )
}